import {SelectionModel} from '@angular/cdk/collections';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Activity, Level} from '../../../../models/applicationFeature';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
  selector: 'app-assign-levels-to-activity',
  templateUrl: './assign-levels-to-activity.component.html',
  styleUrls: ['./assign-levels-to-activity.component.scss']
})
export class AssignLevelsToActivityComponent implements OnInit {
  activity: Activity;
  levels: MatTableDataSource<Level>;
  selection: SelectionModel<Level>;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  displayColumns = ['select', 'description'];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private commonService: CommonService,
              public toastMessagesService: ToastMessagesService,
              public dialogRef: MatDialogRef<AssignLevelsToActivityComponent>) {
    this.levels = new MatTableDataSource<Level>(data.levels);
    this.activity = data.activity;
    this.selection = new SelectionModel<Level>(true, []);
  }

  ngOnInit(): void {
    this.commonService.setPaginatorTexts(this.paginator);
    this.levels.sort = this.sort;
    this.levels.paginator = this.paginator;
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;

    // @ts-ignore
    const numRows = this.levels.data.length;

    return numSelected === numRows;
  }

  public masterToggle(): void {
    // @ts-ignore
    this.isAllSelected() ? this.selection.clear() : this.levels.data.forEach((row) =>
      this.selection.select(row));
  }

  assign() {
    this.close(this.selection.selected);
  }

  close(value?: Level[]) {
    this.dialogRef.close(value);
  }
}
